import type { Recipe } from '../types';
import { bratwurstLentilSoup } from './bratwurst-lentil-soup';
import { mongolianBeef } from './mongolian-beef';
import { freezerBreakfastBurritos } from './freezer-breakfast-burritos';
import { grandpasChili } from './grandpas-chili';
import { splitPotChickenWhiteBeanSoup } from './split-pot-chicken-white-bean-soup';
import { bananaOatProteinMuffins } from './banana-oat-protein-muffins';
import { cottageCheeseEggBites } from './cottage-cheese-egg-bites';
import { bakedMeatballsRedSauce } from './baked-meatballs-red-sauce';
import { hoagieRolls } from './hoagie-rolls';
import { mississippiPotRoast } from './mississippi-pot-roast';
import { homemadeMississippiPotRoast } from './homemade-mississippi-pot-roast';
import { southernSkilletCornbread } from './southern-skillet-cornbread';
import { koreanBeefBowls } from './korean-beef-bowls';
import { porkCarnitas } from './pork-carnitas';
import { chickenEnchiladaBake } from './chicken-enchilada-bake';
import { buttermilkWaffles } from './buttermilk-waffles';
import { peanutButterProteinBites } from './peanut-butter-protein-bites';
import { hamburgerVegetableSoup } from './hamburger-vegetable-soup';
import { chickenPotPieBake } from './chicken-pot-pie-bake';

// Add a recipe: create its file in this folder, import it, append it here.
// Order = order added (newest last); the catalog's "recently added" sort reads it.
export const recipes: Recipe[] = [
  bratwurstLentilSoup,
  mongolianBeef,
  freezerBreakfastBurritos,
  grandpasChili,
  splitPotChickenWhiteBeanSoup,
  bananaOatProteinMuffins,
  cottageCheeseEggBites,
  bakedMeatballsRedSauce,
  hoagieRolls,
  mississippiPotRoast,
  homemadeMississippiPotRoast,
  southernSkilletCornbread,
  koreanBeefBowls,
  porkCarnitas,
  chickenEnchiladaBake,
  buttermilkWaffles,
  peanutButterProteinBites,
  hamburgerVegetableSoup,
  chickenPotPieBake,
];

export function getRecipe(slug: string): Recipe | undefined {
  return recipes.find((r) => r.slug === slug);
}
